<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="直播列表" class="common-header">
                <mt-button slot="left" icon="back" @click="goBack"></mt-button>
            </mt-header>
        </div>
        <div>
            <div v-if="ifComponent" class="mt-5 pb-30" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
                <div v-if="miniproLiveList && miniproLiveList.length">
                    <div class="live-item mb-5" v-for="(item,index) in miniproLiveList" :key="item.minipro_live_id">
                        <div class="content">
                            <div class="live-header">
                                <div class="live-name">{{item.minipro_live_name}}[直播ID:{{item.minipro_live_id}}]</div>
                                <div class="live-state">
                                    <span>已通过</span>
                                </div>
                            </div>
                            <div v-if="item.goods_list" class="goods-list">
                                <div class="goods-item" v-for="(goods,i) in item.goods_list" :key="i">
                                    <img class="goods-image" :src="goods.goods_image_url" />
                                </div>
                            </div>
                            <div class="live-btn">
                                <div v-if="ifComponent" class="common-btn ds-button-small edit-wrapper" @click="onUse(index,item.minipro_live_id)">应用</div>
                            </div>
                        </div>
                    </div>
                </div>
                <empty-record v-else />
            </div>
            <div v-else>
                <img src="../../../assets/image/minipro_live.jpg" style="width:100%" />
            </div>
			<div class='common-add-btn-wrapper'><div class="div common-btn common-add-btn"  @click="onAdd">新增</div></div>
        </div>
    </div>
</template>

<script>
import { Toast, Indicator, MessageBox } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getRoomList } from '../../../api/sellerMiniproLive'
import { loadScript } from '../../../util/common'
export default {
  name: 'CostList',
  props: {
    ifComponent: {
      type: Boolean,
      default: false
    }
  },
  components: {
    EmptyRecord
  },
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      miniproLiveList: false, // 记录列表
      inMinipro: 0
    }
  },
  created () {
    let _this = this
    loadScript('weixin', 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js', function () {
      _this.inMinipro = 2
    })
  },
  computed: {
    getBannerStyle: function () {
      const { width, height } = window.screen
      let itemWidth = width
      let itemHeight = height - 44
      return {
        maxWidth: itemWidth + 'px',
        maxHeight: itemHeight + 'px'
      }
    }

  },
  methods: {
    goMiniproLive (room_id) {
      if (this.inMinipro == 0) {
        Toast('环境加载中，请稍等')
        return
      }
      
      let _this = this
      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          _this.inMinipro = 1
        }
      })
      if (this.inMinipro == 2) {
        Toast('请在小程序中打开')
        return
      }
      if (this.inMinipro == 1) {
        wx.miniProgram.navigateTo({ url: 'plugin-private://wx2b03c6e691cd7370/pages/live-player-plugin?room_id=' + room_id })
      }
    },
    onUse (index, minipro_live_id) {
      this.$emit('useMiniproLive', minipro_live_id)
    },
    onAdd () {
      if (this.ifComponent) {
        this.$emit('addMiniproLive')
      } else {
        this.$router.push({ name: 'SellerMiniproLiveForm', query: { action: 'add' } })
      }
    },
    goBack () {
      if (this.ifComponent) {
        this.$emit('closeMiniproLiveList')
      } else {
        this.$router.go(-1)
      }
    },
    getMiniproLiveList (ispush) {
      Indicator.open()
      let params = this.params
      getRoomList(params).then(res => {
        Indicator.close()

        if (ispush && this.miniproLiveList) {
          this.miniproLiveList = this.miniproLiveList.concat(res.result.minipro_live_list)
        } else {
          this.miniproLiveList = res.result.minipro_live_list
        }
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
        this.loading = false
      }).catch(error=>{
          Indicator.close()
          Toast(error.message)
      })
    },
    loadMore () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.getMiniproLiveList(true)
      }
    },
    reload () {
      // 重新加载数据
      this.loading = false
      this.params.page = 0
      this.isMore = true
      this.miniproLiveList = false
      this.loadMore()
    }
  }
}
</script>

<style scoped lang="scss">
.common-header{
        .btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
    }
.live-item{padding:.5rem;border-bottom:1px solid #eee;background:#fff;
    .live{width:8rem;height: 6rem;background: #000}
    .content{font-size:$subFontSize;padding-left:.5rem;
        .live-header{display: flex;
            .live-name{flex:1}
            .live-state{color:$primaryColor}
        }
        .goods-list{white-space: nowrap;width: 100%;overflow: hidden;overflow-x: auto;margin-top: .5rem;
            .goods-item{display: inline-block;margin-right: .5rem;width: 5rem;height: 5rem;
                .goods-image{width: 100%;height: 100%}
            }
        }
        .live-btn{padding-top:.5rem;overflow: hidden;
            .edit-wrapper{margin-left:1rem;float: right}
        }
    }
}
.my-popup {
    text-align: center;
    position: fixed;
    background: #fff;
    top: 50%;
    left: 50%;
    -webkit-transform: translate3d(-50%, -50%, 0);
    transform: translate3d(-50%, -50%, 0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transition: .2s ease-out;
    transition: .2s ease-out;}
</style>
